import { useTranslation } from '../i18n';
import './TypingIndicator.css';

/** Three bouncing dots, ~3-8s long since Gemma 31b is slow. Visible text
 *  label for screen readers; dots are decorative. */
export function TypingIndicator() {
  const { t } = useTranslation();
  return (
    <div
      className="cf-typing"
      role="status"
      aria-live="polite"
      aria-label={t('chat.typing')}
    >
      <span className="cf-typing__dots" aria-hidden="true">
        <span className="cf-typing__dot" />
        <span className="cf-typing__dot" />
        <span className="cf-typing__dot" />
      </span>
      <span className="cf-visually-hidden">{t('chat.typing')}</span>
    </div>
  );
}
